export enum Product {
  Eks = 'EKS',
  Rlv = 'RLV',
  Dkr = 'DKR',
}
